import HTTPServices from "../HTTPServices/httpService";

const stuffServices = {
  //(1)
  getAllStuffs: async function () {
    console.log("'getAllStuffs' service called:: " + "");
    return await HTTPServices.get("stuff/getAll");
  },

    //(2)
    getAllTailors: async function () {
        console.log("'getAllTailors' service called:: " + "");
        return await HTTPServices.get("stuff/getAllTailors");
      },

  //(3)
  getAllOfficeStuffs: async function () {
    console.log("'getAllOfficeStuffs' service called:: " + "");
    return await HTTPServices.get("stuff/getAllOfficeStuffs");
  },
};

export default stuffServices;
